import { useCallback, useRef } from 'react';
import { v4 as uuid } from 'uuid';

interface LeadMessageSendAttempt {
  draftKey: string;
  generation: number;
  requestId: string;
}

export const useLeadMessageSendAttempt = (draftKey: string) => {
  const draftRef = useRef({ key: draftKey, generation: 0 });
  const attemptRef = useRef<LeadMessageSendAttempt | null>(null);

  if (draftRef.current.key !== draftKey) {
    draftRef.current = {
      key: draftKey,
      generation: draftRef.current.generation + 1,
    };
    attemptRef.current = null;
  }

  const getSendAttempt = useCallback((): LeadMessageSendAttempt => {
    if (!attemptRef.current) {
      attemptRef.current = {
        draftKey: draftRef.current.key,
        generation: draftRef.current.generation,
        requestId: uuid(),
      };
    }

    return attemptRef.current;
  }, []);

  const isCurrentSendAttempt = useCallback(
    (attempt: LeadMessageSendAttempt): boolean =>
      attempt.generation === draftRef.current.generation &&
      attempt.draftKey === draftRef.current.key,
    []
  );

  return { getSendAttempt, isCurrentSendAttempt };
};
